import format from 'date-fns/format';

export function getDateTime(value?: number | Date): string {
  try {
    return value ? format(new Date(value), 'dd.MM.yyyy HH:mm') : '';
  } catch (_err) {
    return '';
  }
}
